
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";

import ConsultaPergunta from '../../../../../lib/json/consultas/Perguntas.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import { ConsultaAPI } from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import SelectFixo from "../../../../components/SelectFixo";
import { CancelarButton } from "../../../../components/SubmitForm/styles";
import ResponsiveDataTable from "../../../../components/DataTable";

function FichaPergunta(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idPergunta } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaPergunta.consulta + (idPergunta ? ` WHERE Id = '${idPergunta}'` : '');

    var [campoDescricao, setCampoDescricao]   = useState([]);
    var [campoTipoResposta, setCampoTipoResposta]   = useState({value: ' ', text: 'Selecione o Tipo de Resposta'});
    var [campoPreDefinidos, setCampoPreDefinidos]   = useState([]);
    var [dataRespostas, setDataRespostas]   = useState([]);

    const optionsTipoResposta = [
        {value: "T", text: 'Resposta Curta'}, 
        {value: "P", text: 'Parágrafo'},
        {value: "N", text: 'Númerico'}, 
        {value: "M", text: 'Multipla Escolha'},
        {value: "C", text: 'Caixas de Seleção'},
        {value: "L", text: 'Lista Suspensa'},
        {value: "A", text: 'Anexo'},
        {value: "D", text: 'Data'},
        {value: "H", text: 'Horário'},
        {value: "V", text: 'Valor Monetário'},
        {value: "I", text: 'Incremental'},
    ]

    useEffect(() => {
        if (idPergunta){
            setInclusao(false)
            loadPergunta();
        }
    }, []);

    // Processa consulta do grid
    const loadPergunta = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        if (retConsulta.data){
            setCampoDescricao(retConsulta.data[0].Descricao);
            
            let option = retConsulta.data[0].OpcoesResposta;
            let newData = option ? option.split(';').map((item) => { return {descricao: item } }) : []

            let tipoResposta = {value: retConsulta.data[0].TipoResposta, text: optionsTipoResposta.filter( item => item.value == retConsulta.data[0].TipoResposta )[0].text}
            
            setCampoTipoResposta(tipoResposta);
            setDataRespostas(newData);
        }
        
        setCarregar(false);
    }

    const btnIncluirRespostas = () => {
        if (!campoPreDefinidos){
            toast.warning('O prenchimento do campo Resposta é obrigatório.');
            return;
        }
        
        setDataRespostas((prevData) => [...prevData, { descricao: campoPreDefinidos}]);

        btnCancelarResposta()
    };

    const btnCancelarResposta = () => {
        setCampoPreDefinidos("")
    }

    const handleExcluirResposta = (row) => {
        const deletar = row.original.descricao;
        const newData = dataRespostas.filter((item) => item.descricao != deletar)

        setDataRespostas(newData);        
    };

    const handleSalvar = async() =>{
        try {
            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoDescricao) {
                toast.warning('O prenchimento do campo Descrição é obrigatório.');
                return;
            }

            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoTipoResposta.value) {
                toast.warning('O prenchimento do campo Tipo Resposta é obrigatório.');
                return;
            }

            setCarregar(true);
            const rota = 'perguntas' + (inclusao ? '' : '/' + idPergunta);
            
            let tipoResposta = campoTipoResposta.value
            let OpcoesResposta = dataRespostas.map( item => {return item.descricao} ).join(';')
            let jsonSalvar = {
                descricao: campoDescricao,
                tipoResposta: tipoResposta,
                opcoes: OpcoesResposta
            }

            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, jsonSalvar)
                : ConsumoAPI_PUT(rota, jsonSalvar));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Pergunta"/>
            </Col>
            <Col md="8" xs="12">
                <InputGeral 
                    label="Descição"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
                />
            </Col>
            <Col md="4" xs="12">
                <SelectFixo 
                    options={optionsTipoResposta} 
                    value={campoTipoResposta} 
                    selectedOptionValue={campoTipoResposta} 
                    isLabel={true} 
                    label="Tipo Resposta" 
                    onChange={(selectedOption) => setCampoTipoResposta(selectedOption)}
                />
            </Col>
        </Row>
        
        { 'M/C/L'.includes(campoTipoResposta.value) && (
            <Row>
                <Col md="10" xs="12">
                    <InputGeral 
                        label="Resposta"
                        tipo='text'
                        value={campoPreDefinidos}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoPreDefinidos(e.target.value)}
                        upperCase={false}
                    />
                </Col>
                <Col md="2" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                    <Button variant="primary" onClick={btnIncluirRespostas}>✚ Adicionar</Button>
                    <CancelarButton variant="danger" onClick={btnCancelarResposta}>✗ Cancelar</CancelarButton>
                </Col>
            </Row>
        )}

        {dataRespostas && dataRespostas.length > 0 && (
            <ResponsiveDataTable 
                habilitaBuscar={false} 
                columns={[{Header: 'Resposta Pré Definida',accessor: 'descricao',}]} 
                data={dataRespostas} 
                isIgnorar={true}
                buttons= {[
                    {action: handleExcluirResposta, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                ]}
            />
        )}
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaPergunta;